
<template>
    
        <mars-view class="step-one"><mars-view class="box"><mars-view class="title">
            退款进度
            <mars-view :class="['status', status === 5 ? 'red' : '']">{{ statusText[status] }}</mars-view></mars-view><mars-view class="content process">
            {{ processContent }}
        </mars-view></mars-view><mars-view class="box"><mars-view class="title">
            退款信息
        </mars-view><mars-view class="lawyer-info" @click.native="clickLawyer"><mars-image class="image" :src="submitData.lawyer_avatar"></mars-image><mars-view class="name">{{ submitData.lawyer_name }}律师</mars-view><mars-view class="arrow"></mars-view></mars-view><mars-view class="content"><mars-view class="sub-title">
                电话咨询
            </mars-view><mars-view class="price">￥{{ submitData.refund_price | priceFormat }}</mars-view><mars-view class="time"><mars-view>下单时间：</mars-view><mars-view>{{ submitData.create_time }}</mars-view></mars-view><mars-view v-if="submitData.pay_time" class="time pay-time"><mars-view>支付时间：</mars-view><mars-view>{{ submitData.pay_time }}</mars-view></mars-view></mars-view><mars-view v-if="submitData.refund_reason" class="content"><mars-view class="sub-title">退款原因</mars-view><mars-view id="reason" class="reason"><mars-view id="reason-real" class="reason-real">
                    {{ submitData.refund_reason }}
                </mars-view><mars-view v-if="showMoreButton" class="more-reason" @click.native="clickReason">... 全部</mars-view></mars-view></mars-view><mars-view v-if="submitData.refund_pics && submitData.refund_pics.length" class="content"><mars-view class="sub-title">已上传凭证</mars-view><mars-view class="pic-list"><mars-view v-for="item, index in submitData.refund_pics" :key="index" class="pic-item"><mars-image mode="aspectFit" :src="item" class="image" @click.native="previewImage(item)"></mars-image></mars-view></mars-view></mars-view></mars-view><mars-view v-if="status === 2" class="cancel" @click.native="cancel">
        取消退款
    </mars-view><base-popup title="退款原因" :show="isShowPopup" :close-on-click-overlay="true" @close="close"><mars-view>
            {{ submitData.refund_reason }}
        </mars-view></base-popup></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import { request } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import { nav } from '../../static/utils/navigate.js';
import basePopup from "../common/basePopup.vue";
import log from '../../static/utils/ubcLog';
export default {
  data() {
    return {
      isSubmit: false,
      isShowPopup: false,
      statusText: ['', '', '审核中', '退款中', '退款成功', '退款失败', '退款已取消'],
      showMoreButton: false
    };
  },
  filters: {
    priceFormat(val) {
      return val && (val / 100).toFixed(2) || 0;
    }
  },
  components: {
    'base-popup': basePopup
  },
  props: {
    orderId: {
      type: String,
      default: ''
    },
    // 提交申请时的数据
    submitData: {
      type: Object,
      default: () => {}
    },
    // 2审核中，3退款中，4退款成功，5退款失败，6退款已取消
    status: {
      type: Number,
      default: 0
    }
  },
  computed: {
    processContent() {
      const map = {
        6: '您已取消退款',
        5: '拒绝理由：' + this.submitData.audit_reason,
        4: '律师审核通过，已原路退款。'
      };
      return map[this.status] || '预计14个工作日内完成您的退款，请耐心等待';
    }
  },
  watch: {
    submitData: {
      handler(val) {
        if (val.refund_reason) {
          setTimeout(() => {
            this.setReasonMore();
          }, 100);
        }
      },
      immediate: true,
      deep: true
    },
    status: {
      handler(val) {
        // 2审核中，3退款中，4退款成功，5退款失败，6退款已取消
        // 退款页面曝光打点
        if (val) {
          log.addKey && log.addKey({
            status: val
          });
          log.send && log.send({
            serverId: 17167,
            action: 'show',
            area: 'refund-show'
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    //  取消退款申请
    cancel() {
      if (this.isSubmit) {
        return;
      }
      this.isSubmit = true;
      // 取消退款按钮点击打点
      log.send && log.send({
        serverId: 17167,
        action: 'click',
        area: 'cancel-click'
      });
      request({
        url: reqPathTo('cancelrefund', {}, '', 'falv/order'),
        data: {
          order_id: this.orderId
        },
        method: 'post',
        loginNeeded: false,
        needBduss: true,
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        res = res && res.data;
        if (res && +res.status === 0) {
          this.$api.showToast({
            title: ' 取消退款成功',
            icon: 'none'
          });
          nav({
            url: '/pages/myconsult/index?tab=pay',
            type: 'relaunch'
          });
          return;
        }
        this.$api.showToast({
          title: ' 取消退款失败，请稍候再试~',
          icon: 'none'
        });
      }).finally(() => {
        this.isSubmit = false;
      });
    },
    /**
     * 预览图片
     * @param {String} url 预览的图片链接
     */

    previewImage(url) {
      this.$api.previewImage({
        current: url,
        urls: this.submitData.refund_pics
      });
    },
    /**
     * 点击律师
     */

    clickLawyer() {
      log.send && log.send({
        serverId: 17167,
        action: 'click',
        area: 'lawyer-tiaohome-click'
      });
      this.submitData.lawyer_home_link && nav({
        url: this.submitData.lawyer_home_link
      });
    },
    /**
     * 点击更多，展示退款原因弹窗
     */

    clickReason() {
      log.send && log.send({
        serverId: 17167,
        action: 'click',
        area: 'lawyer-more-click'
      });
      this.isShowPopup = true;
    },
    close() {
      this.isShowPopup = false;
    },
    // 判断原因是否展示更多按钮
    setReasonMore() {
      const query = getApp().$api.createSelectorQuery();
      query.select('#reason').boundingClientRect();
      query.select('#reason-real').boundingClientRect().exec((res = []) => {
        let answerContent = res[0] && res[0].height;
        let answerAll = res[1] && res[1].height;
        this.showMoreButton = answerContent < answerAll;
      });
    }
  }
};
</script>

<style scoped>
.step-one textarea {
  outline: none;
}
.step-one .box {
  margin: 0 0.08rem;
  background: #fff;
  border: 0.5px solid #edf0fc;
  border-radius: 0.12rem;
  padding: 0.16rem 0.13rem;
  position: relative;
  z-index: 1;
}
.step-one .box:not(:first-child) {
  margin-top: 0.08rem;
}
.step-one .box.explain {
  padding-bottom: 0.11rem;
}
.step-one .box .title {
  font-family: PingFangSC-Medium;
  font-size: 0.17rem;
  color: #1e1f24;
  letter-spacing: 0;
  line-height: 1;
  font-weight: 500;
  margin-bottom: 0.14rem;
  position: relative;
}
.step-one .box .title .status {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #848691;
  line-height: 1;
  font-weight: 400;
  margin-left: 0.08rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.step-one .box .title .status.red {
  color: #ff3e4a;
}
.step-one .box .lawyer-info {
  display: flex;
  align-items: center;
  position: relative;
}
.step-one .box .lawyer-info .image {
  width: 0.24rem;
  height: 0.24rem;
  border-radius: 50%;
  border: 0.5px solid #edf0fc;
}
.step-one .box .lawyer-info .name {
  font-family: PingFangSC-Medium;
  font-size: 0.16rem;
  color: #50525c;
  line-height: 1;
  font-weight: 500;
  margin-left: 0.06rem;
}
.step-one .box .lawyer-info .arrow {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 0.16rem;
  width: 0.16rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/lawyersSquare/icon-arrow.png') no-repeat center center / 100% 100%;
}
.step-one .box .content {
  font-size: 0.14rem;
  color: #848691;
  line-height: 1;
  font-weight: 400;
  background: rgba(245, 246, 249, 0.7);
  padding: 0.13rem;
  border: 0.5px solid #edf0fc;
  border-radius: 0.09rem;
  position: relative;
  margin-top: 0.12rem;
}
.step-one .box .content .sub-title {
  font-family: PingFangSC-Medium;
  font-size: 0.16rem;
  color: #50525c;
  line-height: 0.17rem;
  font-weight: 500;
  margin-bottom: 0.1rem;
}
.step-one .box .content .time {
  display: flex;
}
.step-one .box .content .time.pay-time {
  margin-top: 6px;
}
.step-one .box .content .price {
  position: absolute;
  right: 0.11rem;
  top: 0.11rem;
  font-family: PingFangSC-Medium;
  font-size: 0.16rem;
  color: #ff5353;
  letter-spacing: 0;
  line-height: 0.17rem;
  font-weight: 500;
}
.step-one .box .content .reason {
  line-height: 0.22rem;
  overflow: hidden;
  max-height: 0.66rem;
  text-align: justify;
  position: relative;
}
.step-one .box .content .reason .more-reason {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #f5f6f9;
  color: #1e1f24;
}
.step-one .box .content .reason .more-reason::before {
  content: "";
  width: 60px;
  height: 100%;
  position: absolute;
  left: -60px;
  top: 0;
  background: linear-gradient(to right, rgba(245, 246, 249, 0), #f5f6f9);
}
.step-one .box .content .pic-list {
  display: flex;
}
.step-one .box .content .pic-list .upload {
  flex-shrink: 0;
  flex-grow: 0;
}
.step-one .box .content .pic-list .pic-item {
  width: 0.89rem;
  height: 0.89rem;
  border-radius: 0.09rem;
  position: relative;
  box-sizing: border-box;
  border: 0.5px #edf0fc solid;
  flex-shrink: 0;
  flex-grow: 0;
}
.step-one .box .content .pic-list .pic-item .image {
  width: 100%;
  height: 100%;
  border-radius: 0.09rem;
}
.step-one .box .content .pic-list .pic-item:not(:last-child) {
  margin-right: 0.05rem;
}
.step-one .box .content .pic-list .pic-item .clear-icon {
  height: 0.18rem;
  width: 0.18rem;
  position: absolute;
  right: 0.05rem;
  top: 0.05rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/clear-icon.png') no-repeat center center / 100% 100%;
}
.step-one .box .content.process {
  line-height: 0.18rem;
}
.step-one .cancel {
  font-family: PingFangSC-Semibold;
  font-weight: 700;
  font-size: 0.18rem;
  color: #1e1f24;
  text-align: center;
  line-height: 1;
  font-weight: 600;
  margin-top: 0.3rem;
}
.step-one /deep/ .popup .content {
  padding: 0 0.17rem 0.18rem;
}
.step-one [class*='popup'] [class*='__content'] {
  padding: 0 0.17rem 0.18rem;
}

</style>
